<template>
    <div class="main1">
        <div class="cont">
            <div class="cont_tabs">
                <el-tabs v-model="activeName" type="card">
                    <el-tab-pane label="室内图" name="roomPicture">
                        <span slot="label">
                            <span>室内图({{imageList.surveyIndoorPicture?imageList.surveyIndoorPicture.length:0}})
                            </span>
                        </span>
                        <div class="indoor">
                            <div v-for="(item,index) in imageList.surveyIndoorPicture" :key="index" @click="surveyIndoorPictureImg(imageList.surveyIndoorPicture)">
                                <div class="indoor_pic">
                                    <img :src="'http://'+item.uri" alt="">
                                    <div v-if="details.approvalStatusValue!=='TO_BE_AUDITED'&&details.approvalStatusValue!=='UNABLE'" class="indoor_pic_deleticon" @click.stop="deletImg(item.id)">
                                        <img class="" src="../../assets/images/deletImg.png" alt="">
                                    </div>
                                </div>
                                <div class="txt">
                                    <!-- <el-input @input="saveChange(item)" v-model="item.label" placeholder="请标签内容"></el-input> -->
                                    <el-autocomplete popper-class="my-autocomplete" v-model="item.label" :fetch-suggestions="getImageLabelList" placeholder="请输入内容" @select="handleSelect">
                                        <template slot-scope="{ item }">
                                            <div class="valueDesc" @select="handleSelect">{{ item.value }}</div>
                                        </template>
                                    </el-autocomplete>
                                </div>
                            </div>

                            <div v-for="(item,index) in surveyIndoorPicture" :key="index">
                                <div class="indoor_pic">
                                    <img :src="'http://'+item.uri" alt="">
                                </div>
                                <div class="txt">
                                    <el-autocomplete popper-class="my-autocomplete" v-model="item.label" :fetch-suggestions="getImageLabelList" placeholder="请输入内容" @select="handleSelect">
                                        <template slot-scope="{ item }">
                                            <div class="valueDesc" @select="handleSelect">{{ item.value }}</div>
                                        </template>
                                    </el-autocomplete>
                                </div>
                            </div>
                            <div class="indoor_pic" @click="showPicList('surveyIndoorPicture')">
                                <i class="el-icon-plus iconfont icon-icon_huxing "></i>
                            </div>
                            <div class="indoor_text">注意：照片请使用真实照片，格式支持jpeg、png等</div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="户型图" name="houseTypePicture">
                        <span slot="label">
                            <span>户型图({{imageList.surveyApartmentPicture?imageList.surveyApartmentPicture.length:0}})</span>
                        </span>

                        <div class="indoor">
                            <div class="indoor_pic" v-for="(item,index) in imageList.surveyApartmentPicture" :key="index" @click="surveyIndoorPictureImg(imageList.surveyApartmentPicture)">
                                <img :src="'http://'+item.uri" alt="">
                                <div v-if="details.approvalStatusValue!=='TO_BE_AUDITED'&&details.approvalStatusValue!=='UNABLE'" class="indoor_pic_deleticon" @click.stop="deletImg(item.id)">
                                    <img class="" src="../../assets/images/deletImg.png" alt="">
                                </div>
                            </div>
                            <div class="indoor_pic" v-for="item in surveyApartmentPicture" :key="item.uri">
                                <img :src="'http://'+item.uri" alt="">
                            </div>
                            <div class="indoor_pic" @click="showPicList('surveyApartmentPicture')">
                                <i class="el-icon-plus  iconfont icon-icon_huxing"></i>
                            </div>
                            <div class="indoor_text">注意：照片请使用真实照片，格式支持jpeg、png等</div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="保密图" name="vrVideo">
                        <span slot="label">
                            <span>保密图({{imageList.surveySecretPicture?imageList.surveySecretPicture.length:0}})</span>
                        </span>

                        <div class="indoor">
                            <div class="indoor_pic" v-for="(item,index) in imageList.surveySecretPicture" :key="index" @click="surveyIndoorPictureImg(imageList.surveySecretPicture)">
                                <img v-if="permisShow('保密图片查看')" :src="'http://'+item.uri" alt="">
                                <img v-else src="../../assets/buildDetail/wuquanchakans.png" alt="">
                                <div v-if="permisShow('保密图片查看')&&details.approvalStatusValue!=='TO_BE_AUDITED'&&details.approvalStatusValue!=='UNABLE'" class="indoor_pic_deleticon" @click.stop="deletImg(item.id)">
                                    <img class="" src="../../assets/images/deletImg.png" alt="">
                                </div>
                            </div>
                            <div class="indoor_pic" v-for="item in surveySecretPicture" :key="item.uri">
                                <img v-if="permisShow('保密图片查看')" :src="'http://'+item.uri" alt="">
                                <img v-else src="../../assets/buildDetail/wuquanchakans.png" alt="">
                            </div>
                            <div class="indoor_pic" @click="showPicList('surveySecretPicture')">
                                <i class="el-icon-plus  iconfont icon-icon_huxing"></i>
                            </div>
                            <div class="indoor_text">注意：照片请使用真实照片，格式支持jpeg、png等</div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="VR视频" name="secretPicture">
                        <span slot="label">
                            <span>VR视频({{imageList.surveyVrVideo?imageList.surveyVrVideo.length:0}})</span>
                        </span>
                        <div class="indoor">
                            <div class="indoor_pic" v-for="(item,index) in imageList.surveyVrVideo" :key="index">
                                <img :src="'http://'+item.uri" alt="">
                                <div v-if="details.approvalStatusValue!=='TO_BE_AUDITED'&&details.approvalStatusValue!=='UNABLE'" class="indoor_pic_deleticon" @click="deletImg(item.id)">
                                    <img class="" src="../../assets/images/deletImg.png" alt="">
                                </div>
                            </div>
                            <div class="indoor_pic" v-for="item in surveyVrVideo" :key="item.uri">
                                <img :src="'http://'+item.uri" alt="">
                            </div>
                            <div class="indoor_pic" @click="showPicList('surveyVrVideo')">
                                <i class="el-icon-plus  iconfont icon-icon_huxing"></i>
                            </div>
                            <div class="indoor_text">注意：照片请使用真实照片，格式支持jpeg、png等</div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <el-dialog v-if="uploadImgVisible" title="上传图片" :append-to-body="true" :visible.sync="uploadImgVisible" @close="closeBtn">
            <UploadImg uploadData="02" v-if="uploadImgVisible" :isindoorPicture="isindoor" @cancelUpload="uploadImgVisible=false" @saveUpload="upLoadingBtn"></UploadImg>
        </el-dialog>
        <div class="footer">

            <!--      <div class="btn" v-if="details.approvalStatusValue=='AUDITED'||details.approvalStatusValue=='NORMAL'">-->
            <!--        <el-button v-points type="primary" style="background:#FF7F32;border:1px solid #FF7F32;width:80px;margin:0 20px;" @click="sub">反审</el-button>-->
            <!--      </div>-->
            <div class="btn" style="padding-right: 20px;">
                <el-button type="info" style="width:80px;" @click="cls">取消</el-button>
                <el-button v-if="details.approvalStatusValue!=='TO_BE_AUDITED'&&details.approvalStatusValue!=='UNABLE'" v-points type="primary" style="background:#5E75E6;border:1px solid #5E75E6;width:80px;" @click="sub('WAITING_FOR_APPROVAL')">保存</el-button>
                <el-button v-if="whetherOpen&&details.approvalStatusValue!=='TO_BE_AUDITED'&&details.approvalStatusValue!=='NORMAL'&&details.approvalStatusValue!=='AUDITED'&&details.approvalStatusValue!=='UNABLE'" v-points type="primary" style="background:#22CA85;border:1px solid #22CA85;width:110px;margin:0 0 0 10px;" @click="sub('TO_BE_AUDITED')">保存并提交</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import VueCookies from "vue-cookies";
import UploadImg from "@/components/common/uploadImg";
import {
    houseAddSurvey,
    houseUpdateSurvey,
    querySurvey
} from "@/api/houseManage";
import { queryApprovalWhetherOpen } from "@/api/customeManage";
import { uploadDeletImg, dicGet } from "@/api";
import qs from "qs";

export default {
    components: {
        UploadImg
    },
    props: {
        status: {
            type: String,
            default: ""
        },
        permisList: {
            type: Array,
            require: true
        },
        details: {
            type: Object,
            default: {}
        }
    },
    data() {
        //cosole.log(222222222222222222,this.status)
        let token = sessionStorage.getItem("accessToken") || "";
        let userId = sessionStorage.getItem('userId');
        return {
            userId,
            whetherOpen: false,
            activeName: "roomPicture",
            imgIndex: 0,
            surveyIndoorPicture: [],
            surveyApartmentPicture: [],
            surveyVrVideo: [],
            surveySecretPicture: [],
            curIdlist: [],
            imageList: {},
            uploadImgVisible: false,
            imgType: "",
            isindoor: false //是否室内图片
        };
    },

    created() {
        this.querySurveyList();
        this.queryApprovalWhetherOpen();
    },

    methods: {
        surveyIndoorPictureImg(list) {
            this.$emit("HousingSolidImgList", list);
        },
        //查询客源是否开启审批
        queryApprovalWhetherOpen() {
            this.$post(queryApprovalWhetherOpen, { approvalType: "whether_exploration" }).then(res => {
                this.whetherOpen = res.data;
            });
        },
        permisShow(data) {
            // 权限配置
            // console.log(this.permisList,0);
            let result = this.permisList.indexOf(data);
            if (result >= 0) {
                //cosole.log("权限列表", data, result);
                return true;
            } else {
                return false;
            }
        },
        // 获取图片描述列表
        getImageLabelList(queryString, cb) {
            let params = {
                valueDesc: queryString,
                code: "pictureLabel"
            };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    this.ImageLabelList = res.data;
                    let result = this.ImageLabelList;
                    cb(result);
                } else {
                }
            });
        },
        // 图片描述回调
        handleSelect(item) {
            //cosole.log(111, item);
        },
        querySurveyList() {
            let params = {
                buildingInfoId: this.details.buildingInfoId,
                realExplorationId:this.details.realExplorationId
            };
            this.$post(querySurvey, params).then(res => {
                if (res.success) {
                    this.imageList = res.data;
                }
            });
        },

        showPicList(data) {
            if (data == "surveyIndoorPicture") {
                this.isindoor = true;
            } else {
                this.isindoor = false;
            }
            this.uploadImgVisible = true;
            this.imgType = data;
        },

        cls() {
            this.$emit("removeHousingSolid");
        },
        saveChange(data) { },
        upLoadingBtn(data) {
            this.uploadImgVisible = false;
            data.splice(data.length - 1, 1);
            if (this.imgType == "surveySecretPicture") {
                this.surveySecretPicture = this.surveySecretPicture.concat(data);
            } else if (this.imgType == "surveyVrVideo") {
                this.surveyVrVideo = this.surveyVrVideo.concat(data);
            } else if (this.imgType == "surveyApartmentPicture") {
                this.surveyApartmentPicture = this.surveyApartmentPicture.concat(data);
            } else if (this.imgType == "surveyIndoorPicture") {
                this.surveyIndoorPicture = this.surveyIndoorPicture.concat(data);
            }
        },
        closeBtn() {
            this.uploadImgVisible = false;
        },
        deletImg(data) {
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            })
                .then(() => {
                    let params = {
                        picturesId: data,
                        buildingInfoId: this.details.buildingInfoId,
                    };
                    this.$post(uploadDeletImg, params).then(res => {
                        if (res.success) {
                            this.$message({
                                type: "success",
                                message: res.msg
                            });
                            this.querySurveyList();
                        } else {
                            this.$message({
                                type: "error",
                                message: res.msg
                            });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        sub(val) {
            if (
                this.imageList.surveyIndoorPicture ||
                this.imageList.surveyApartmentPicture ||
                this.imageList.surveyVrVideo ||
                this.imageList.surveySecretPicture
            ) {
                let IndoorPicture = "";
                if (this.imageList.surveyIndoorPicture.length != 0) {
                    IndoorPicture = this.surveyIndoorPicture.concat(
                        this.imageList.surveyIndoorPicture
                    );
                } else {
                    IndoorPicture = this.surveyIndoorPicture;
                }
                let params = {
                    roomPicture:
                        IndoorPicture.length != 0 ? JSON.stringify(IndoorPicture) : null,
                    houseTypePicture:
                        this.surveyApartmentPicture.length != 0
                            ? JSON.stringify(this.surveyApartmentPicture)
                            : null,
                    vrVideo:
                        this.surveyVrVideo.length != 0
                            ? JSON.stringify(this.surveyVrVideo)
                            : null,
                    secretPicture:
                        this.surveySecretPicture.length != 0
                            ? JSON.stringify(this.surveySecretPicture)
                            : null,
                    buildingInfoId: this.details.buildingInfoId,
                    status: this.details.houseStatus,
                    approvalStatus: val,
                    id: this.imageList.id
                };
                this.$post(houseUpdateSurvey, params).then(res => {
                    if (res.success) {
                        this.$message({
                            type: "success",
                            message: res.msg
                        });
                        this.$emit("removeHousingSolid");
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg
                        });
                        this.$emit("removeHousingSolid");
                    }
                });
            } else {
                console.log(12321321, this.surveySecretPicture);
                let params = {
                    roomPicture: JSON.stringify(this.surveyIndoorPicture),
                    houseTypePicture: JSON.stringify(this.surveyApartmentPicture),
                    vrVideo: JSON.stringify(this.surveyVrVideo),
                    secretPicture: JSON.stringify(this.surveySecretPicture),
                    buildingInfoId: this.details.buildingInfoId,
                    status: this.details.houseStatus,
                    approvalStatus: val,
                };
                this.$post(houseAddSurvey, params).then(res => {
                    if (res.success) {
                        this.$message({
                            type: "success",
                            message: res.msg
                        });
                        this.$emit("removeHousingSolid");
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg
                        });
                        this.$emit("removeHousingSolid");
                    }
                });
            }
        }
    }
};
</script>
<style lang="less">
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height: 90px;
    line-height: 90px;
    text-align: center;
}
.avatar {
    width: 128px;
    height: 90px;
    display: block;
}
.cont_tabs {
    margin-right: 60px;
    .el-tabs__header {
        margin: 0;
        .el-tabs__nav-wrap {
            //   align-items: center;
            background: #f5f5f5;
            .el-tabs__nav {
                border: none;
            }
            .el-tabs__item {
                width: 160px;
                line-height: 38px;
                color: #999;
                border: none;
                &.is-active {
                    color: #5e75e6;
                    border-top: 4px solid #5e75e6;
                    height: 44px;
                    background: #fff;
                }
                > span {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
    }

    .indoor {
        display: flex;
        align-items: top;
        justify-content: flex-start;
        flex-wrap: wrap;
        font-size: 12px;
        color: #999;
        margin-top: 30px;
        .el-input {
            margin-top: 10px;
            width: 120px;

            .el-input__inner {
                height: 30px;
                background: #f5f5f5;
                border: 1px solid #ccc;
                padding-left: 10px;
                padding-right: 10px;
            }
        }
        // .txt{
        //   font: 14px/24px '';

        // }
        .indoor_pic {
            margin-top: 10px;
            min-width: 130px;
            height: 90px;
            background: #eee;
            border: 1px solid #999;
            border-radius: 5px;
            margin-right: 20px;
            // display: flex;
            // justify-content: center;
            // align-items: center;
            position: relative;
            overflow: hidden;
            text-align: center;
            .icon-icon_huxing {
                font-size: 30px;
                line-height: 90px;
            }
            &_deleticon {
                width: 70px;
                height: 70px;
                border-radius: 50%;
                position: absolute;
                top: -35px;
                right: -35px;
                background: rgba(102, 102, 102, 0.3);
                > img {
                    width: 20px !important;
                    margin: 40px 20px 40px 0;
                }
            }

            > img {
                width: 128px;
                height: 90px;
            }
        }
        .indoor_text {
            width: 130px;
            margin-top: 25px;
        }
    }
}
</style>


